import { queryOptions } from '@tanstack/react-query';

import { entityRolesClient } from './client';

export const ENTITY_ROLES_QUERY_KEYS = {
  catalog: 'entity-permission-catalog',
  roles: 'entity-roles',
  role: 'entity-role',
  roleMembers: 'entity-role-members',
  memberPermissions: 'entity-member-permissions',
};

/**
 * The permission catalogue. Immutable for the life of a deployment — the labels,
 * descriptions and groups come from a backend registry that only changes when the
 * enum does, so it is worth caching hard rather than refetching per board visit.
 */
export const _getPermissionCatalog = () =>
  queryOptions({
    queryKey: [ENTITY_ROLES_QUERY_KEYS.catalog],
    queryFn: () => entityRolesClient.getCatalog(),
    staleTime: Infinity,
    gcTime: Infinity,
  });

/**
 * Every query below is keyed on the selected entity: roles are organisation-scoped,
 * so switching entity must not show the previous organisation's roles.
 */
export const _getEntityRoles = (entityId?: string | null) =>
  queryOptions({
    enabled: !!entityId,
    queryKey: [ENTITY_ROLES_QUERY_KEYS.roles, entityId],
    queryFn: () => entityRolesClient.getRoles(),
  });

export const _getEntityRole = (entityId?: string | null, roleId?: string | null) =>
  queryOptions({
    enabled: !!entityId && !!roleId,
    queryKey: [ENTITY_ROLES_QUERY_KEYS.role, entityId, roleId],
    queryFn: () => entityRolesClient.getRole(roleId as string),
  });

export const _getEntityRoleMembers = (entityId?: string | null, roleId?: string | null) =>
  queryOptions({
    enabled: !!entityId && !!roleId,
    queryKey: [ENTITY_ROLES_QUERY_KEYS.roleMembers, entityId, roleId],
    queryFn: () => entityRolesClient.getRoleMembers(roleId as string),
  });

export const _getEntityMemberPermissions = (entityId?: string | null, userId?: string | null) =>
  queryOptions({
    enabled: !!entityId && !!userId,
    queryKey: [ENTITY_ROLES_QUERY_KEYS.memberPermissions, entityId, userId],
    queryFn: () => entityRolesClient.getMemberPermissions(userId as string),
  });
